import { render, staticRenderFns } from "./CryptoBackpack.vue?vue&type=template&id=0856352a"
import script from "./CryptoBackpack.vue?vue&type=script&lang=js"
export * from "./CryptoBackpack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports